export const sqZh = {
  sq: {
    numberOfQuestions: '题目数量',
    totalScore: '总分',
    tiemremaning: '倒计时',
    member: '成员',
    testSample: '样题',
    tip1: '提示：请调整设备音量，并在倒计时结束前进行样题体验',
    send: '发送',
    back: '返回',
    replay: '重播',
    nextQquestion: '下一题即将开始',
    ok: '完成',
    gotIt: '好的',
    chatroomTip: '官方倡导绿色健康的互动体验，不传播任何不良信息，请大家文明发言。'
  }
}
export const sqEn = {
  sq: {
    numberOfQuestions: 'Number of Questions',
    totalScore: 'Total score',
    tiemremaning: 'TIME REMAINING',
    member: 'Member',
    testSample: 'Sample Test',
    tip1: 'Attention: Please turn up the device volume, and take the "Sample Test" before the countdown ends! ',
    send: 'SEND',
    back: 'BACK',
    replay: 'Replay',
    nextQquestion: 'Next question upcoming',
    ok: 'OK',
    gotIt: 'Got it',
    chatroomTip: 'Please speak in a civilized manner. '
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/sq/index.js